import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/app-shared/src/public-api';
import { EcommerceGenericoService } from 'projects/ecommerce-generico/src/public-api';

@Component({
  selector: 'modal-compra-online',
  templateUrl: './modal-compra-online.component.html',
  styleUrls: ['./modal-compra-online.component.scss']
})

export class ModalCompraOnlineComponent implements OnInit {

  constructor(private modal: ModalService, private genServ : EcommerceGenericoService) { }

  ngOnInit(): void {
  }

  aceptar() {
    this.modal.close('modal-compra-online');
  }

  get compraOnline(){
    return this.genServ.getinfoCompra()
  }

  get errorMessage() {
    return this.genServ.getErrorMessage();
  }

}
